import { useQuery } from "@tanstack/react-query";
import {
  fetchAPI,
  TASKS_SERVICE_URL,
} from "@coworker/app/src/hooks/API/tasks.service.helper";
import { ItemExpectedDeliveryResponse } from "../../types/itemExpectedDeliveryResponse";
import { FetchApiResponse } from "@coworker/apprestructured/src/shared/types/fetchApiResponseType";

async function fetchItemExpectedDelivery(
  itemNo: string
): Promise<ItemExpectedDeliveryResponse> {
  const url = `${TASKS_SERVICE_URL}/items/item-expected-delivery?itemNo=${itemNo}`;
  const { result } = (await fetchAPI("GET", url)) as FetchApiResponse;
  return result as ItemExpectedDeliveryResponse;
}

export function useItemExpectedDelivery(itemNo: string) {
  return useQuery<ItemExpectedDeliveryResponse>({
    queryKey: ["item", "expected", "delivery", itemNo],
    queryFn: async () => await fetchItemExpectedDelivery(itemNo),
    staleTime: 86400000, // 1 day, considered fresh for a day.
    refetchOnWindowFocus: false,
    enabled: !!itemNo,
  });
}
